export const getItemNmber = (
    pageNumber: number  ,
    pageSize: number  
  ) => {
     
    const firstIndexNumber = pageNumber * pageSize - pageSize;
    return firstIndexNumber;
};
